/**
 * Type definitions for assets exported in website FLibs
 * @typedef {Object} AssetsExport
 * @property {string} logo
 */

/**
 * Type definitions for functions exported in website FLibs
 * @typedef {Object} FLibsExport
 * @property {AssetsExport} assets
 * @property {(date?: Date, format?: TimeFormatType) => string} getFormattedDateString
 * @property {(date: Date) => string} formatDateToStringUS
 * @property {<ValueType>(key: string, defaultValue: ValueType) => ({ state: ValueType, setState: (value: React.SetStateAction<ValueType>) => void })} useSyncLocalStorage
 */

/**
 * Add type so that the properties are suggested
 * @type {FLibsExport}
 */
const FLibsExports = window.FLibs

module.exports = FLibsExports
